/**
 * Implementation of the top bar in the main component,
 * which displays the title of the page.
 *
 * Copyright © Ircam Amplify 2024-2026
 */
import { ReactNode } from 'react'
import './TopBar.css'

interface TopBarProps {
  title: string
  description?: string
  className?: string
  rightNestedComp?: ReactNode
}

export default function TopBar(props: TopBarProps) {
  return (
    <div id="topbar" className={`topbar ${props.className ?? ''}`}>
      <div id="titlebar">
        <h1>{props.title}</h1>
        {props.description && <p>{props.description}</p>}
      </div>
      {props.rightNestedComp}
    </div>
  )
}
